export const CONFIG = {
  steno: {
    name: 'Steno',
    aiName: 'niro',
    description: 'Steno is a voice assistant that can help you with your tasks.',
    calendarUrl: 'https://calendly.com/armanassadi/demo?hide_gdpr_banner=1',
    formFields: {
      firstname: { type: 'text', label: 'First Name', required: true },
      lastname: { type: 'text', label: 'Last Name', required: true },
      email: { type: 'email', label: 'Email Address', required: true },
      company: { type: 'text', label: 'Company Name', required: true },
      website: { type: 'text', label: 'Company Website', required: false },
      phone: { type: 'tel', label: 'Phone Number', required: false },
    },
  },
  solar4good: {
    name: 'Solar4Good',
    aiName: 'solar4good',
    description: 'Solar4Good is a voice assistant that can help you with your tasks.',
    calendarUrl: null,
    formFields: {
      firstname: { type: 'text', label: 'First Name', required: true },
      lastname: { type: 'text', label: 'Last Name', required: true },
      email: { type: 'email', label: 'Email Address', required: true },
      phone: { type: 'tel', label: 'Contact Number', required: true },
      postcode: { type: 'text', label: 'Postcode', required: true },
    },
  },
};

// Default to 'steno' if not specified
export const getActiveConfig = () => {
  const configKey = process.env.NEXT_PUBLIC_ACTIVE_CONFIG || 'steno';
  return CONFIG[configKey as keyof typeof CONFIG] || CONFIG.steno;
};
